import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  dialog: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    margin: 0,
    zIndex: theme.zIndex.modal,
    [theme.breakpoints.up('sm')]: {
      left: 'inherit',
      right: theme.spacing(4),
      bottom: theme.spacing(3),
      boxShadow: theme.shadows[2],
    },
  },
  backDrop: {
    backgroundColor: 'transparent',
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.lighter,
    padding: theme.spacing(2, 4),
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
    [theme.breakpoints.up('sm')]: {
      borderRadius: theme.spacing(1, 1, 0, 0),
    },
  },
  dialogContent: {
    maxWidth: theme.spacing(55),
    margin: 0,
    padding: theme.spacing(3, 2, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 4, 1),
    },
  },
  actions: {
    padding: theme.spacing(0, 2, 4),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 4, 4),
    },
  },
  noAceptButton: {
    marginTop: theme.spacing(2),
  },
  aceptButton: {
    margin: theme.spacing(2, 0, 0, 2),
  },

  dialogTitleColorAlternative: {
    backgroundColor: theme.palette.secondary.lighter,
  },
  dialogContentLinkColorAlternative: {
    color: theme.palette.primary.dark,
  },
  aceptButtonColorAlternative: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
    '&:active, &:hover, &:focus': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
  },
  noAceptButtonColorAlternative: {
    color: theme.palette.primary.dark,
    '&:active, &:hover, &:focus': {
      color: theme.palette.primary.dark,
    },
  },
}))

export default useStyles
